
import Component, { mixins } from "vue-class-component";
import { Line, mixins as chartMixins } from "vue-chartjs";
import { Prop } from "vue-property-decorator";

@Component({
    mixins: [chartMixins.reactiveProp],
})
export default class LineChart extends mixins(Line) {
	@Prop() chartData: any;
	@Prop() options: any;
    mounted() {
        this.renderChart(
            this.chartData,
            this.options
        );
    }
}
